/** Country / region options for project site address (shared across forms and display). */
export const PROJECT_COUNTRY_OPTIONS = [
  { value: "usa", label: "🇺🇸 United States (USA)" },
  { value: "can", label: "🇨🇦 Canada (CAN)" },
  { value: "gbr", label: "🇬🇧 United Kingdom (GBR)" },
  { value: "irl", label: "🇮🇪 Ireland (IRL)" },
  { value: "aus", label: "🇦🇺 Australia (AUS)" },
  { value: "nzl", label: "🇳🇿 New Zealand (NZL)" },
  { value: "open", label: "Open / not specified" },
];

export const COUNTRY_LABELS = {
  usa: "United States",
  can: "Canada",
  gbr: "United Kingdom",
  irl: "Ireland",
  aus: "Australia",
  nzl: "New Zealand",
  open: "Open / not specified",
};

const CELSIUS_COUNTRY_CODES = new Set([
  "gbr",
  "gb",
  "uk",
  "united kingdom",
  "irl",
  "ie",
  "ireland",
]);

const FAHRENHEIT_COUNTRY_CODES = new Set(["usa", "us", "united states"]);

/** UK and Ireland format locality as city, region, postcode. */
export function usesUkStyleLocality(countryCode) {
  const cc = (countryCode || "").toLowerCase();
  return cc === "gbr" || cc === "irl";
}

export function getTemperatureFieldLabel(countryCode) {
  const cc = (countryCode || "usa").toLowerCase().trim();
  if (CELSIUS_COUNTRY_CODES.has(cc)) {
    return "Temperature (°C)";
  }
  if (FAHRENHEIT_COUNTRY_CODES.has(cc)) {
    return "Temperature (°F)";
  }
  return "Temperature";
}

/** Labels and controls for the region + postal fields by country. */
export function getAddressFieldConfig(countryCode) {
  switch ((countryCode || "usa").toLowerCase()) {
    case "usa":
      return {
        regionLabel: "State",
        postalLabel: "ZIP Code",
        regionPlaceholder: "Select state",
        postalPlaceholder: undefined,
        useUsStateDropdown: true,
      };
    case "can":
      return {
        regionLabel: "Province / Territory",
        postalLabel: "Postal Code",
        regionPlaceholder: "e.g. ON",
        postalPlaceholder: undefined,
        useUsStateDropdown: false,
      };
    case "gbr":
      return {
        regionLabel: "County",
        postalLabel: "Postcode",
        regionPlaceholder: "e.g. Greater Manchester",
        postalPlaceholder: "e.g. SW1A 1AA",
        useUsStateDropdown: false,
      };
    case "irl":
      return {
        regionLabel: "County",
        postalLabel: "Eircode",
        regionPlaceholder: "e.g. Dublin",
        postalPlaceholder: "e.g. D02 AF30",
        useUsStateDropdown: false,
      };
    case "aus":
      return {
        regionLabel: "State / Territory",
        postalLabel: "Postcode",
        regionPlaceholder: "e.g. NSW",
        postalPlaceholder: undefined,
        useUsStateDropdown: false,
      };
    case "nzl":
      return {
        regionLabel: "Region",
        postalLabel: "Postcode",
        regionPlaceholder: "e.g. Auckland",
        postalPlaceholder: undefined,
        useUsStateDropdown: false,
      };
    default:
      return {
        regionLabel: "State / Province / Region",
        postalLabel: "Postal Code",
        regionPlaceholder: "State / province / region",
        postalPlaceholder: undefined,
        useUsStateDropdown: false,
      };
  }
}
